import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const useStyles = makeStyles({
  icon: {
    color: 'inherit',
    justifyContent: 'center',
    marginLeft: '-12px',
    marginRight: '12px',
  },
  active: {
    background: 'rgba(0, 125, 170, 0.08)',
  },
})

/**
 * Configuration of ListItem to be used in sidebar
 * @param {object} props
 * @prop {object} icon
 * @prop {node} iconComponent
 * @prop {string} label
 * @prop {string} to
 * @prop {func} onSelectLink
 * @returns SidebarListItem Component
 */
const SidebarListItem = ({ icon, iconComponent, label, to, href, onSelectLink, pathname, id, disabled }) => {
  const classes = useStyles()
  const regex = new RegExp(to)
  const isActive = to && regex.test(pathname)
  return (
    <ListItem
      id={id}
      className={cn({ [classes.active]: isActive })}
      aria-current={isActive ? 'page' : undefined}
      alignItems="center"
      component={href ? 'a' : to ? Link : undefined}
      to={to}
      href={href}
      button
      onClick={onSelectLink}
      disabled={disabled}
    >
      <ListItemIcon className={classes.icon}>
        {iconComponent || (
          <FontAwesomeIcon
            icon={icon}
            size="lg"
          />
        )}
      </ListItemIcon>
      <ListItemText primary={label} />
    </ListItem>
  )
}

SidebarListItem.propTypes = {
  icon: PropTypes.object,
  iconComponent: PropTypes.node,
  id: PropTypes.string,
  label: PropTypes.string,
  onSelectLink: PropTypes.func,
  pathname: PropTypes.string,
  to: PropTypes.string,
}

export default SidebarListItem
